import { useTranslation } from 'react-i18next';
import { ConnectisPrimaryLogo } from 'shared/icons';
import { ServiceUnavailableImg } from 'shared/icons/ServiceUnavailableImg';

export const ServiceUnavailablePage = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common:serviceUnavailable',
  });

  return (
    <main className="flex min-h-full-device flex-col bg-lightBlue">
      <header className="flex h-12 w-full items-center bg-white shadow-error-header lg:h-16">
        <ConnectisPrimaryLogo className="ml-4 flex w-[120px] md:ml-6 md:w-[136px] lg:mb-0" />
      </header>
      <div className="mx-auto flex min-h-full flex-1 flex-col items-center justify-center gap-8 lg:flex-row lg:gap-20">
        <div>
          <ServiceUnavailableImg className="max-h-[360px] w-screen max-w-full p-4 px-[72px] lg:max-h-full lg:max-w-[519px] lg:px-0" />
        </div>
        <div className="max-w-[343px] space-y-3 text-center sm:my-4 md:max-w-[500px] lg:text-left">
          <h2 className="text-lg font-bold md:text-2xl">{t('title')}</h2>
          <p className="text-sm text-gray-500 md:text-lg lg:whitespace-pre-line">{t('subtitle')}</p>
        </div>
      </div>
    </main>
  );
};

export default ServiceUnavailablePage;
